<template>
    <div>
        <b-container fluid class="top-padding bottom-padding no-horiz-padding">
            <img style="max-width: 100%" :src='this.getSiteImageUrl("iStock-000015582770-hw-site-banner-caption.jpg")' />
        </b-container>
        <b-container fluid class="top-padding bottom-padding no-horiz-padding">

            <h1>Welcome to Handweaving.net!</h1>
            <p>Handweaving.net is a digital weaving archive with drafts, historic weaving documents, and more. This website contains {{patternsCount}} hand weaving drafts, many of which are public domain. </p>

            <h2 class="top-padding">Weaving Drafts</h2>

            <p>We provide complete
                <router-link to="/drafts">draft collections</router-link> produced from a large number of works on weaving. Samples:</p>
            <div class="inline-auto-width" :key='pattern.PatternID' v-for="pattern in this.$store.state.homePagePatterns">
                <router-link :to='buildDraftDetailUrl(pattern)' :title="pattern.Tooltip">
                  <img class="draft-image-thumbnail" :src="draftImageUrlFunction(pattern.PatternID, 2, currentOrientation, false, false, false, false, false, false, false, false, false, false, pattern.ImagesExist)" :alt="'Drawdown Image: ' + pattern.Tooltip" />
                </router-link>
            </div>

            <div class="bottom-padding">
                <b-button variant='primary' to="/drafts">Browse Drafts &raquo;</b-button>
            </div>

            <div v-if='!this.isSubscriber'>
                <h2 class="top-padding">Subscriptions</h2>
                <p>
                    We offer low cost
                    <router-link to="/subscription">subscriptions</router-link> to support providing and expanding this site for you.
                </p>

                <div class="right-padding bottom-padding">
                    <b-button variant='primary' @click='navigateToSubscription'>Learn More &raquo;</b-button>
                </div>
            </div>

            <div>
                <h2 style='display: inline-block; padding-right: 1rem;' class="top-padding">Draft Color Editor </h2>
                <img style='max-width: 12rem; padding-bottom: 0.3rem;' :src='this.getSiteImageUrl("color-bar.png")' />
            </div>
            
            <div>
                <p>We have added a draft color editor where you can instantly apply different colors to any Handweaving.net draft or to your own drafts!</p>
                <div class="right-padding bottom-padding">
                    <b-button variant='primary' to='/draft-editor-introduction'>Learn More &raquo;</b-button>
                </div>
            </div>

            <div>
                <h2 style='display: inline-block; padding-right: 1rem;' class="top-padding">Video Tutorials </h2>
            </div>
            
            <div>
                <p>We have added a YouTube channel with short video tutorials to help you learn to get the most from this site!</p>
                <div class="right-padding bottom-padding">
                    <b-button variant='primary' target="_blank" href="https://www.youtube.com/channel/UCbQhW5AwY9hYsXAXbyg3qmQ">View our Video Tutorials &raquo;</b-button>
                </div>
            </div>            

            <h2 class="top-padding">Gallery</h2>

            <p>
                We have added a gallery page on Facebook where you can share and discuss projects made using Handweaving.net drafts! Please share photos of your beautiful weaving to inspire others.
            </p>

            <div class="right-padding bottom-padding">
                <b-button variant='primary' target="_blank" href="https://www.facebook.com/Handweaving.net">Visit our Facebook Gallery &raquo;</b-button>
            </div>

            <div class="top-padding inline-auto-width">
                <h2>Digital Archive</h2>
                Ralph Griswold's Digital Archive of Documents on Hand Weaving, Lace, and Related Topics is available through this site! This is a fascinating and useful library of more than 8000 high quality digital reproductions of original works.
                <p class='vertical-padding'>
                    <router-link to="/documents">
                        <img class='right-padding bottom-padding' :src='this.getSiteImageUrl("SwiftSmall.jpg")' />
                    </router-link>
                    <b-button variant='primary' to="/documents">Browse Weaving Documents &raquo;</b-button>
                </p>
            </div>
            <div class="top-padding inline-auto-width">
                <h2>Handweaving.net Store</h2>
                We now offer
                <a router-link to="/digital-downloads">digital downloads</a> of most draft collections, and CDs with nearly all of the documents in the Griswold Archive on Weaving, Textiles, Lace, and Related Topics!
                <p class='vertical-padding'>
                    <a href="">
                        <img class='right-padding bottom-padding' :src='this.getProductImageUrl("TaleOfTwoTieups.png")' />
                    </a>
                    <b-button variant='primary' href="http://store.handweaving.net" target="_blank">Visit our Store &raquo;</b-button>
                </p>
            </div>

            <help-us-button/>
            <mail-chimp-signup/>
        </b-container>

    </div>
</template>

<script>
import dataService from '../mixins/dataService.js'
import mediaService from '../mixins/mediaService.js'
import urlsService from '../mixins/urlsService.js'
import helpUsButton from './HelpUsButton.vue'
import mailChimpSignup from './MailChimpSignup.vue'

export default {
    mixins: [dataService, mediaService, urlsService],
    name: 'Home',

    data() {
        return {
            patternsCount: ''
        }
    },
    created() {
        this.$store.commit('setPageTitle', 'Weaving Draft and Documents Archive')
        this.fetchData()
    },
    components: {
        helpUsButton: helpUsButton,
        mailChimpSignup: mailChimpSignup
    },
    methods: {
        fetchData() {
            var countToRetrieve = 5
            var maxWarpThreads = 75
            var maxWeftThreads = 75

            let minShafts = 1
            let maxShafts = 100
            let maxTreadles = 100
            let maxFloatLength = 100

            if (this.$store.state.homePagePatterns.length === 0) {
                this.getRandomPatterns(countToRetrieve, minShafts, maxShafts, maxTreadles, maxFloatLength, maxWarpThreads, maxWeftThreads).then(resp => {
                    let patternsList = resp.data
                    this.$store.commit('setHomePagePatterns', patternsList)
                })
            }

            this.getPatternsCount().then(resp => {
                this.patternsCount = resp.data
            })
        },
        navigateToSubscription() {
            this.$router.push({ name: 'Subscription' })
        }
    },

    computed: {
        isSubscriber: function() {
            return this.$store.getters.isSubscriber
        },
        draftImageUrlFunction: function() {
            return this.$store.state.draftImageUrlFunction
        },
        currentOrientation: function() {
            if (this.$store.getters.isSubscriber) {
                return this.$store.state.authUserSettings.Orientation
            }
            return 'tl'
        }
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.draft-image-thumbnail {
    vertical-align: bottom;
    padding: 0.6rem;
}
</style>




// WEBPACK FOOTER //
// src/components/Home.vue